"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
require("./SearchInput.scss");
var SearchInput = /** @class */ (function (_super) {
    __extends(SearchInput, _super);
    function SearchInput(props) {
        var _this = _super.call(this, props) || this;
        _this.renderClear = function () {
            if (!_this.props.value || _this.props.value.length === 0) {
                return null;
            }
            return react_1.default.createElement("i", { className: "acl-i-times-circle", onClick: function () { return _this.props.onChange(""); } });
        };
        _this.state = {
            focusing: false,
        };
        return _this;
    }
    SearchInput.prototype.render = function () {
        var _this = this;
        return (react_1.default.createElement("div", { className: "results-search " + (this.state.focusing ? "results-search__focused" : "") },
            react_1.default.createElement("i", { className: "acl-i-search" }),
            react_1.default.createElement("input", { type: "text", role: "search", className: "results-search__input", value: this.props.value, onChange: function (e) { return _this.props.onChange(e.target.value); }, onFocus: function () { return _this.setState({ focusing: true }); }, onBlur: function () { return _this.setState({ focusing: false }); }, placeholder: this.props.placeholder, "aria-label": this.props.placeholder }),
            this.renderClear()));
    };
    SearchInput.propTypes = {
        placeholder: prop_types_1.default.string,
        value: prop_types_1.default.string,
        onChange: prop_types_1.default.func,
    };
    return SearchInput;
}(react_1.Component));
exports.default = SearchInput;
//# sourceMappingURL=SearchInput.js.map